//--------------------------------------------
//
// Oculus Model
//
//--------------------------------------------
'use strict';

import q from 'q';
import THREE from 'three';


const Oculus = () => {
	
	const self = this;
	const deferred = q.defer();

	const geometrySrc = 'data/oculus.js';

	const loader = new THREE.JSONLoader();
	const texLoader = new THREE.TextureLoader();

	let oculus;

	loader.load(
		geometrySrc,
		(geometry) => {


			texLoader.load(
				'data/OculusBand.jpg',
				(texture) => {


					texLoader.load(
						'data/Cloth_BUMP.jpg',
						(bump) => {

							const material = new THREE.MeshPhongMaterial({
								color: 0x000000
							});

							oculus = new THREE.Mesh(geometry, material);

							oculus.position.z = -125;

							deferred.resolve(oculus);

						}
					)
				}
			);
		}
	);


	return deferred.promise;
}


export default Oculus;
